import type { CampaignWithCampTypesAndLocationsT } from "@/app/types/campaigns";

/**
 * Extract all offer IDs that are assigned to campaigns
 *
 * @param campaigns - Array of campaigns with related offers
 * @returns Set of offer IDs that are assigned to at least one campaign
 *
 * @example
 * ```tsx
 * const offerIdsInCampaigns = getOfferIdsFromCampaigns(campaigns);
 * const offersWithoutCampaign = offers.filter(
 *   (offer) => !offerIdsInCampaigns.has(offer.id)
 * );
 * ```
 */
export function getOfferIdsFromCampaigns(
  campaigns: CampaignWithCampTypesAndLocationsT[]
): Set<string> {
  return new Set(
    campaigns.flatMap(
      (campaign) => campaign.related_offers?.map((offer) => offer.id) || []
    )
  );
}
